<template>
  <div id="app" class="vue">
    <!-- router -->
    <div :class="iframe_css">
      <router-view />
    </div>
    <!-- top -->
    <div class='public_top'>
      <img class="logo fl" src="./assets/images/logo.png" />
      <!-- 新增辅助快捷导航栏 -->
      <div class="top_nav fl">
        <router-link to="/all_edges" class="a_link fl"><span class="a_link_span">医院</span></router-link>
        <router-link to="/applies" class="a_link fl"><span class="a_link_span">列表</span></router-link>
        <router-link to="/license_apply" class="a_link fl"><span class="a_link_span">申请</span></router-link>
        <router-link to="/lic_upload" class="a_link fl"><span class="a_link_span">上传</span></router-link>
      </div> 
      <div class="pt_middle ab_middle_right clear">
        <img class="icon_ fl" src="./assets/images/default.jpg" />
        <p class="base_info omit fl">您好，{{ role }}，{{ name }}</p>
        <img class="logout fl" src="./assets/images/out.png" @click="logout" />
      </div>
      <!-- <div class="top_mid fr">
        <span class="fl">License Management System VERSION {{ version }} 2024@copyright</span>
      </div> -->
    </div>
    <!-- left -->
    <div class='public_left'>
      <ul style="padding: 0; margin: 0;">
        <li id='public_left_li_' :class='tpl_css'>
          <router-link to="/home" :class='top_css'>
            <span class='icon icon-support'></span>
            <span class='public_left_li_title'>首页</span>
          </router-link>
        </li>
        <li v-for='(item, index1) in menu' :class='item.css' v-bind:key="item.id">
          <a :class='item.a_css' @click='nav_click(item)'>
            <span :class='item.before'></span>
            <span class='public_left_li_title'>{{ item.title }}</span>
            <span :class='item.after'></span>
          </a>
          <ul class='inner_ul' :id='item.id'>
            <li :class="child.active === true ? 'public_left_child_li plcl_active' : 'public_left_child_li'"
               v-for='(child, index2) in item.children' v-bind:key="child.title">
              <router-link :to='child.href' @click.native="go_other(child, index1, index2)" class="public_left_child_li_link">
                <span class='public_left_li_title_'>{{ child.title }}</span>
                <span class='public_left_arrow'></span>
              </router-link>
            </li>
          </ul>
        </li>
        <li class='public_left_li menu_close'>
          <a @click="go_full" class='close'>
            <span class='icon icon-frame'></span>
            <span class='public_left_li_title'>全屏模式</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<style>
@import '@/assets/icons/icon.css';
@import '@/assets/css/public/common.css';
@import '@/assets/css/html/home.css';

.vue {
  position: fixed;
  width: 100%;
  height: 100%;
}
.ab_middle_right {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}
.top_nav {
  width: 650px;
  height: 100%;
  margin-left: 30px;
}
.a_link {
  width: 150px;
  height: 100%;
}
.a_link_span {
  width: 100%;
  height: 100%;
  line-height: 100px;
  font-size: 20px;
  color: beige;
}
</style>

<script>
import m from '@/utils/menu'
import $ from 'jquery';

export default {
  name: 'App',
  data() {
    return {
      interval: null,
      // top
      role: '未登录',
      name: '未登录',
      version: '1.0.0',
      // left
      tpl_css: 'top_open',
      top_css: 'open',
      menu: m(),
      count: 0,
      iframe_css: 'iframe_wrap',
      base: '',
      block_height: 50,
      father_index: -1,
      child_index: -1
    }
  },
  methods: {
    logout() {
      // 出
      var _this = this;
      _this.$common.request("/login/logout", {}, false, null, function () {
        localStorage.removeItem("token");
        _this.name = '';
        _this.role = '';
        _this.status_interval()
        _this.$router.push("/login");
      }, function () {

      }, function () {

      }, null, '', function () { });
    },
    go_index() {
      var _this = this
      _this.$router.push('/home')
    },
    nav_click: function nav_click(item) {
      var _this = this;
      var to_height = '0';
      var obj = $('#' + item.id);
      if (item.status === 0) {
        item.status = 1;
        item.css = 'public_left_li menu_open';
        item.a_css = 'open';
        item.after = 'public_left_open';
        to_height = item.children_count * _this.block_height;
        _this.count++;
      } else {
        _this.count--;
        item.status = 0;
        item.css = 'public_left_li menu_close';
        item.a_css = 'close';
        item.after = 'public_left_close';
      }
      // if (_this.count === 0) {

      // }
      obj.animate({
        height: to_height
      }, 200);
    },
    go_other(item, index1, index2) {
      var _this = this;
      if (_this.father_index !== -1 && _this.child_index !== -1) {
        _this.menu[_this.father_index].children[_this.child_index].active = false;
      }
      _this.father_index = index1;
      _this.child_index = index2;
      item.active = true;
    },
    go_full() {

    },
    status_interval() {
      var _this = this
      if (_this.name === '') {
        _this.interval = setInterval(() => {
          if (_this.name === '') {
            const token = _this.$common.get_auth()
            if (token !== null) {
              _this.name = token.admin_name
              _this.role = token.role_str
            }
          } else {
            clearInterval(_this.interval)
          }
        }, 2000);
      }
    }
  },
  created() {
    var _this = this
    // setTimeout(() => {
    //     _this.$keycloak.initKeycloak(()=>{
    //     console.log('已登录')
    //     console.log(_this.$keycloak.getUserInfo())
    //     // router.push('/login')
    //   }, ()=>{
    //     //未登录则跳转到登录界面
    //     console.log('未登录')
    //     setTimeout(() => {
    //       _this.$keycloak.dologin()
    //     }, 5000);
    //     // router.push('/login')
    //   })
    // }, 5000);
    
    const token = _this.$common.get_auth()
    if (token === null) {
      // 没有登录信息
      _this.status_interval()
      // _this.$router.push("/login")
    } else {
      _this.name = token.admin_name
      _this.role = token.role_str
    }




    // this.$keycloak.dologin()
  },
  destroyed() {

  }
}
</script>
